export default __webpack_public_path__ + "static/media/meals_male@2x.b1d940d2.png";